import { render } from "./piano.vue?vue&type=template&id=2e9b79d8&scoped=true"
import script from "./piano.vue?vue&type=script&lang=js"
export * from "./piano.vue?vue&type=script&lang=js"

import "./piano.vue?vue&type=style&index=0&id=2e9b79d8&lang=scss&scoped=true"
import "./piano.vue?vue&type=style&index=1&id=2e9b79d8&lang=css"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9b79d8"]])

export default __exports__